import React, { useState } from 'react';
import './Gallery.css';

import office1 from './Images/Office1.jpg';
import Shipment2 from './Images/Shipment2.jpg';
import Shipment1 from './Images/Shipment1.jpg';



const galleryData = [
   
   
    {
        id: 1,
        name: 'Office',
        image: office1,
        title: 'Main Office Ankleshwar',
        description: '',
        about: '',
    },
    {
        id: 2,
        name: 'Shipment',
        image: Shipment1,
        title: 'Shipment to USA',
        description: '',
        about: '',
    },
    {
        id: 3,
        name: 'Hydrogenerated Vegetable oil Type-I, Type-II',
        image: Shipment2,
        title: 'Shipment to USA',
        description: '',
        about: '',
    }
    
];

const Gallery = () => {
    const [modalImage, setModalImage] = useState(null);

    const openModal = (item) => {
        setModalImage(item);
    };

    const closeModal = () => {
        setModalImage(null);
    };

    return (
        <div className="gallery-container">
            <div className="gallery-heading">📷 Our Gallery</div>
            <div className="gallery-grid">
                {galleryData.map((item) => (
                    <div key={item.id} className="gallery-card" onClick={() => openModal(item)}>
                        <img src={item.image} alt={item.name} className="gallery-image" />
                        <h3 className="gallery-name">{item.name}</h3>

                        <div className="hover-panel">
                            <h4>{item.title}</h4>
                            <div className="hover-description">
                                <p>{item.description}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Modal */}
            {modalImage && (
                <div className="image-modal" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-button" onClick={closeModal}>✖</button>
                        <img src={modalImage.image} alt={modalImage.name} className="modal-img" />
                        <h2>{modalImage.name}</h2>
                        <p><strong>{modalImage.title}</strong></p>
                        {modalImage.about && (
                            <div className="about-scroll">
                                <h4>About</h4>
                                <p>{modalImage.about}</p>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Gallery;
